import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {featurePointsAssigneeEdit_template} from "../components/templates/featurePointsAssigneeEdit_template";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class featurePointsAssignee_edit extends vnModule_knockoutJS{
    protected validationsList: validationsList_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected editForm: featurePointsAssigneeEdit_template;

    protected getModuleName(){
        return "featurePointsAssignee_edit";
    }

    buildContent() : Array<Element>{

        this.editForm = new featurePointsAssigneeEdit_template( "featurePointsAssigneeEdit_template", this.viewModel, this );

        return [this.editForm.build()];
    }

    public fillPage() : void{

        this.getReferences();
    }

    protected getReferences(): void{

        let usrReq_url: string = '/api/featurePoints/assignee/config/references/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReferencesDataReturn;
        this.XHRHdl.execute();
    }

    public onGetReferencesDataReturn(req, obj: featurePointsAssignee_edit): Function{

        return function (){
            obj.manageResponse(req, obj, () => {

                let responseParsed = JSON.parse(req.request.response);
                obj.editForm.setupReferences(responseParsed.departments);
                obj.getListData();
            });
        }
    }

    public getListData(): void{

        this.loadingIn(this.editForm.builtTemplate.children.namedItem("list-results"));
        this.editForm.getTemplateViewModel().isResultsLoading(1);

        let idAssignee: number;

        if((idAssignee = this.getVnAppZone().app.params.idAssignee) && !isNaN(idAssignee)){

            let subViewModel = this.editForm.getViewModelForRequest();

            let usrReq_url: string = '/api/featurePoints/config/assignee/'+idAssignee+'/get/';
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)] );
            this.XHRHdls["getListData"] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

            this.XHRHdls["getListData"].onReadyStateFunction = this.onDataRequestReturn;
            this.XHRHdls["getListData"].execute();
        }
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                obj.editForm.validationsList.clearMessages();

                let responseParsed = JSON.parse(req.request.response);

                obj.editForm.setAssigneeProperties(responseParsed.data);
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.editForm.getTemplateViewModel().isResultsLoading(0);
                obj.loadingOut(obj.editForm.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    protected save(): void {

        let formReq_url: string = '/api/featurePoints/config/assignee/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.editForm.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);

        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onPostAssigneeData;
        XHRHdl.execute();
    }

    protected cancelAssigneeEdit(){


        // redirect to earnings page or user list
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "User action canceled !");

        page.redirect('/feature_points/config/view');
    }

    protected saveAssignee() {
        this.save();
    }

    private onPostAssigneeData(req, obj) {
        return function() {

            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Assignee data saved successfully!");
                page.redirect('/feature_points/config/view');

            });
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/featurePointsAssignee_edit.ts